import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { Store as StoreIcon } from '@mui/icons-material';

import PriceTag from './PriceTag';
import ProductImage from './ProductImage';
import { COLORS, FONT_BODY } from './storefrontStyles';

export const productPath = (storeId, productId) =>
    `/tienda/${storeId}/producto/${productId}`;

// Logo chiquito de la tienda al lado de su nombre (feed del home). Sin foto o
// si falla la carga, el ícono de tienda como en el resto del home.
const StoreLogo = ({ src, name }) => {
    const [failed, setFailed] = useState(false);

    return (
        <Box
            sx={{
                width: 16,
                height: 16,
                borderRadius: '4px',
                overflow: 'hidden',
                flexShrink: 0,
                backgroundColor: '#13233A',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            {src && !failed ? (
                <Box
                    component="img"
                    src={src}
                    alt={name}
                    loading="lazy"
                    onError={() => setFailed(true)}
                    sx={{
                        width: 16,
                        height: 16,
                        objectFit: 'cover',
                        display: 'block',
                    }}
                />
            ) : (
                <StoreIcon sx={{ fontSize: 11, color: '#555' }} />
            )}
        </Box>
    );
};

// Tarjeta de producto de la vidriera: imagen, nombre, precio y (en el feed del
// home) la tienda con su logo. Tocarla abre el detalle del producto.
const ProductCard = ({ product, store, sx }) => {
    const image = product.images && product.images[0];

    return (
        <Box
            component={RouterLink}
            to={productPath(product.storeId, product.productId)}
            sx={{
                display: 'flex',
                flexDirection: 'column',
                textDecoration: 'none',
                color: 'inherit',
                backgroundColor: COLORS.card,
                border: `0.5px solid ${COLORS.border}`,
                borderRadius: '8px',
                overflow: 'hidden',
                transition: 'border-color 0.2s, transform 0.2s',
                '&:hover': {
                    borderColor: COLORS.borderHover,
                    transform: 'translateY(-3px)',
                },
                ...sx,
            }}
        >
            <ProductImage src={image && image.url} alt={product.name} />
            <Box
                sx={{
                    p: 1.5,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 0.5,
                }}
            >
                {store && store.name && (
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 0.75,
                            minWidth: 0,
                        }}
                    >
                        <StoreLogo
                            src={store.profileImageUrl}
                            name={store.name}
                        />
                        <Typography
                            sx={{
                                color: COLORS.muted,
                                fontSize: 11,
                                fontFamily: FONT_BODY,
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                            }}
                        >
                            {store.name}
                        </Typography>
                    </Box>
                )}
                <Typography
                    sx={{
                        color: COLORS.text,
                        fontSize: 14,
                        fontWeight: 500,
                        fontFamily: FONT_BODY,
                        lineHeight: 1.3,
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                        minHeight: '2.6em',
                    }}
                >
                    {product.name}
                </Typography>
                <PriceTag
                    price={product.price}
                    compareAtPrice={product.compareAtPrice}
                />
            </Box>
        </Box>
    );
};

export default ProductCard;
